import { render, staticRenderFns } from "./newsinfo_edit.vue?vue&type=template&id=16d156d6&scoped=true"
import script from "./newsinfo_edit.vue?vue&type=script&lang=js"
export * from "./newsinfo_edit.vue?vue&type=script&lang=js"
import style0 from "./newsinfo_edit.vue?vue&type=style&index=0&id=16d156d6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d156d6",
  null
  
)

export default component.exports